<script lang="ts" setup>
import { format, parseISO } from 'date-fns'
import { useRoute } from 'vue-router'
import type { Database } from "~/utils/database.types";
import { useEventDataStore } from '../store/eventDataStore';
import { storeToRefs } from "pinia";
import VueEasyLightbox from 'vue-easy-lightbox'

const supabase = useSupabaseClient<Database>();
const route = useRoute()
const runtimeConfig = useRuntimeConfig();

const vueEasyLightBoxVisibleRef = ref(false);
const vueEasyLightBoxIndexRef = ref(0); // default 0
const vueEasyLightBoxImgsRef = ref([]);

definePageMeta({
    layout: "public",
});

let event = ref<Database["public"]["Tables"]["events"]["Row"]>();
const id = route.query.id;
const preview = route.query.preview;
const isPreview = ref(false);

const GetData = async () => {
    let { data, error } = await useAsyncData("GetTenpoData", async (_) => {
        let { data, error } = await supabase
            .from('events')
            .select('id,title,honbun_html,files(*),gaiyo_text,tenpos(*),koshin_date')
            .eq('id', id)

        if (error) {
            throw new Error("店舗情報の取得に失敗しました。\n\n" + error.message);
        }

        return { data }
    });

    if (error.value || data.value.data.length == 0) {
        console.log("error:", error.value?.message);
    }
    else {
        event.value = data.value.data[0];
    }
};

if (id) {
    await GetData();
}
else if (preview) {
    if (process.client) {
        const eventDataStore = useEventDataStore();
        const { eventAllData } = storeToRefs(eventDataStore);
        isPreview.value = true;
        event.value = eventAllData.value;
    }
}

const breadcrumbs = computed(() => {
    return [{
        path: "/tenpoEvent",
        title: "お店・イベント一覧"
    },
    {
        path: `/tenpoDetail?id=${event.value?.tenpos!.id}`,
        title: event.value?.tenpos?.name
    },
    {
        path: "",
        title: event.value?.title
    }];
})


// ページタイトル
useHead({
    title: event.value?.title + "｜" + runtimeConfig.public.titles.topTitle
})

const onShowViewEasyLightBox = () => {
    vueEasyLightBoxVisibleRef.value = true;
}
const showSingleViewEasyLightBox = (url: string) => {
    vueEasyLightBoxImgsRef.value = url;
    onShowViewEasyLightBox();
}
const onHideViewEasyLightBox = () => (vueEasyLightBoxVisibleRef.value = false)

</script>

<template>
    <div>
        <!-- パンくず表示 -->
        <Breadcrumb :items="breadcrumbs" />

        <!-- タイトル -->
        <div v-if="isPreview" class="text-xl text-red-500 font-bold mb-2">#プレビュー表示中#</div>
        <div v-if="event">
            <PageTitle :pattern="2">{{ event?.title }}</PageTitle>
            <div class="px-8 py-5">
                <!-- 日付部分 -->
                <div class="mb-5 ">
                    <p>{{ format(parseISO(event?.koshin_date), 'yyyy年M月dd日') }}</p>
                </div>
                <div v-if="event.files || event.gaiyo_text" class="lg:flex"
                    :class="{ '!block': !event.files || !event.gaiyo_text }">
                    <!-- 概要画像 -->
                    <div v-if="event.files && event.files.file_url" class="lg:pr-5 w-auto mb-5"
                        :class="{ 'lg:w-[50%]': event.files && event.gaiyo_text }">
                        <p class="block max-w-[100%]">
                            <img :src="event.files.file_url" class="m-auto max-w-[500px] max-h-[350px] max-md:max-w-full"
                                :alt="event.files?.title" @click="showSingleViewEasyLightBox(event.files.file_url)" />
                            <vue-easy-lightbox :visible="vueEasyLightBoxVisibleRef" :imgs="vueEasyLightBoxImgsRef"
                                :index="vueEasyLightBoxIndexRef" @hide="onHideViewEasyLightBox"
                                :rotate-disabled="true"></vue-easy-lightbox>
                        </p>
                    </div>
                    <!-- 概要文 -->
                    <div v-if="event?.gaiyo_text" class="max-lg:pt-5 mb-5"
                        :class="{ 'lg:w-[50%]': event.files && event.gaiyo_text }">
                        <p class="whitespace-pre-line">{{ event?.gaiyo_text }}</p>
                    </div>
                </div>
                <div class="">
                    <!-- 本文 -->
                    <ContentEditorViewer :content-html="event.honbun_html ? event.honbun_html : ''" />
                </div>
            </div>
        </div>
    </div>
</template>